import React from 'react';
import { Paper, Tab, Tabs } from '@material-ui/core';
import { useState } from 'react';
import { TabsStyled } from '../../../../common-client2/src/components';
import './TabSelection.scss';

/**
 * @param {{
 * tabs : {id: number,label: string,onClick: () => void}[]
 * handleTabChange: (id: AdminAppData.NavigationMenuOption) => void
 * }} props
 */
export default function TabSelection(props) {
    const { tabs, handleTabChange } = props;
    const [selectedTab, setSelectedTab] = useState(0);
    /** @param {number} index */
    const a11yProps = (index) => ({ id: `simple-tab-${index}`, 'aria-controls': `simple-tabpanel-${index}` });
    /** @param {number} id */
    const handleTabSelection = (id) => {
        setSelectedTab(id);
        handleTabChange(id);
    };
    return (
        <TabsStyled>
            <div className="admin--dashboard-tabs-container">
                <Paper square>
                    <Tabs
                        indicatorColor="primary"
                        textColor="primary"
                        aria-label="admin tabs"
                        value={selectedTab}
                    >
                        {tabs.map((x, index) => (
                            <Tab
                                key={`${x.id}_${x.label}`}
                                onClick={() => handleTabSelection(x.id)}
                                label={x.label}
                                {...a11yProps(index)}
                            />
                        ))}
                    </Tabs>
                </Paper>
            </div>
        </TabsStyled>
    );
}
